import { getErrorMessage } from 'modules/common/utils/getErrorMessage';
import { IS_PROD } from 'modules/common/constants/env';

interface IExtractViemErrorMessageArgs {
  networkName?: string;
  tokenName?: string;
}

/**
 * This function helps to avoid problems with displaying error messages from Viem.
 *
 * It is because Viem returns a lot of information and also Bigint values that Redux
 * can't handle in raw form.
 */
export function extractViemErrorMessage(
  error: unknown,
  args?: IExtractViemErrorMessageArgs,
): string {
  // The extracted message is surfaced to the user; keep the raw error
  // visible for local debugging only.
  if (!IS_PROD) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  const fullText = getErrorMessage(error);

  const metaMaskMatch = fullText.match(/MetaMask.*?: (.+?)\./);

  if (metaMaskMatch) {
    return metaMaskMatch[1];
  }

  const rejectedMatch = fullText.match(/User (rejected|denied)/i);

  if (rejectedMatch) {
    return 'User rejected the request';
  }

  const isAlreadyHasAdded = fullText.includes(
    'already has added with the same chainId',
  );

  if (isAlreadyHasAdded) {
    if (args?.networkName && args?.tokenName) {
      return `Wallet already contains this network with another currency. Remove it before adding ${args.networkName} with ${args.tokenName}.`;
    }

    return 'Wallet already contains this network with another currency.';
  }

  const firstLine = fullText.split('\n').find(line => line.trim().length > 0);

  return firstLine || 'Unknown error';
}
